import Common from "../../../Common"

const Branding = class extends Common {
	browse = (companyId: id) =>
		this.get(`/company/${companyId}/webchat/branding`)

	read = (companyId: id, brandingId: id) =>
		this.get(`/company/${companyId}/webchat/branding/${brandingId}`)

	create = (companyId: id, body: any) =>
		this.post(`/company/${companyId}/webchat/branding`, body)

	update = (companyId: id, brandingId: id, body: any) =>
		this.post(`/company/${companyId}/webchat/branding/${brandingId}`, body)
}

export default Branding
